import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";
import { MaxLength } from "../../types/MaxLength";

@Component({
  standalone: true,
  selector: "app-prefix-om9",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-om9.component.html",
  styleUrl: "./prefix-om9.component.less",
})
export class PrefixOm9Component extends PrefixTextComponent {
  public maxlength: MaxLength;

  public constructor() {
    super();
    this.maxlength = 30;
    this.required = true;
    this.characters = ALLOWED_CHARACTERS["om9"];
  }
}
